import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectAvvisiComponent } from './components/redirect-avvisi/redirect-avvisi.component';
import { SearchPageComponent } from './components/search-page/search-page.component';
import { NodeComponent } from './shared/components/page-builder/node/node.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { environment } from 'src/environments/environment';


const routes: Routes = [
  { path: 'search', component: SearchPageComponent },
  { path: 'sitemap', component: SitemapComponent },
  { path: 'avviso-non-disponibile', component: RedirectAvvisiComponent },
  { path: 'auth', loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: 'error', loadChildren: () => import('./modules/errors/errors.module').then(m => m.ErrorsModule) },
  { path: '**', component: NodeComponent }
];

for (let lang of environment.languages) {
  routes.unshift({ path: lang.routeCookiePolicy, component: CookiePolicyComponent });
}

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    scrollOffset: [0, 380]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
